// extracted by mini-css-extract-plugin
export var container = "EmbeddedOtherTextField-module__container___Qbr5g";
export var gameTitle = "EmbeddedOtherTextField-module__gameTitle___rzlJw";
export var otherInputContainer = "EmbeddedOtherTextField-module__otherInputContainer___sFu1w";
export var requiredStar = "EmbeddedOtherTextField-module__requiredStar___EXkB2";
export var rowContainer = "EmbeddedOtherTextField-module__rowContainer___6rvyH";
export var textField = "EmbeddedOtherTextField-module__textField___Vh8WS";
export var textFieldText = "EmbeddedOtherTextField-module__textFieldText___xPqah";